import { render } from "./MFAValidateForm.vue?vue&type=template&id=092c17e6"
import script from "./MFAValidateForm.vue?vue&type=script&lang=js"
export * from "./MFAValidateForm.vue?vue&type=script&lang=js"
script.render = render

export default script